import { useEffect, useRef } from 'react';
import { useId } from '../support/useId';

export type InputProps = {
  accept?: string;
  multiple?: boolean;
};

type Options = {
  onFileSelect?: (files: Array<File>) => void;
  inputProps?: InputProps;
};

const formStyles: Partial<CSSStyleDeclaration> = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '0',
  height: '0',
  overflow: 'hidden',
};

export function useFileInput(init: Options = {}) {
  const { onFileSelect, inputProps } = init;

  const onFileSelectRef = useRef(onFileSelect);
  useEffect(() => {
    onFileSelectRef.current = onFileSelect;
  }, [onFileSelect]);

  const id = useId();

  useEffect(() => {
    const form = document.createElement('form');
    Object.assign(form, { id: 'form-' + id, hidden: true });
    Object.assign(form.style, formStyles);
    const input = document.createElement('input');
    Object.assign(input, { type: 'file', id, tabIndex: -1, ...inputProps });
    input.addEventListener('change', () => {
      const files = input.files ? Array.from(input.files) : [];
      onFileSelectRef.current?.(files);
    });
    form.append(input);
    document.body.append(form);
    return () => {
      form.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [id] as const;
}
